import React from 'react'
import styled from '@emotion/styled'
import { ExpandMore } from '@emotion-icons/material/ExpandMore'
import { ExpandLess } from '@emotion-icons/material/ExpandLess'
import { Typography } from '@mui/material'
import { Colors, Shapes } from 'src/components/theme'
import { InsightCardGrid } from '.'
import { InsightCardWrapper } from 'src/components/insights/common/cards/card'
import { GridSize } from '@mui/material'
import { INSIGHT_WIDGET_PRINTABLE_CLASS } from 'src/atoms/report-insight'

type InsightCardProps = {
  id?: string
  title: React.ReactNode
  titleWidth?: GridSize
  top?: React.ReactNode
  showTopOnClose?: boolean
  children?: React.ReactNode
  open: boolean
  onToggle: (open: boolean) => void
}

type InsightCardCollapsibleTableContentProps = {
  open?: boolean
}

export const InsightCardCollapsibleTableWrapper = styled((props: any) => <InsightCardWrapper {...props} />)`
  position: relative;
`

const InsightCardCollapsibleTableHeader = styled.div<InsightCardCollapsibleTableContentProps>`
  padding: ${Shapes.spacing[2]}px;
  height: 52px;
  box-sizing: content-box;
  display: flex;
  align-items: center;
  cursor: pointer;

  & > div > div {
    padding-bottom: ${(props) => (props.open ? '6px' : '0px !important')};
  }
`

const InsightCardCollapsibleTableContent = styled.div<InsightCardCollapsibleTableContentProps>`
  position: relative;
  height: ${(props) => (props.open ? 'auto' : '0px')};
  overflow: ${(props) => (props.open ? 'initial' : 'hidden')};
`

const InsightCardCollapsibleTableToggleWrapper = styled.div`
  position: absolute;
  width: 15px;
  height: 15px;
  top: ${Shapes.spacing[6]}px;
  right: ${Shapes.spacing[5]}px;
`

export const InsightCardCollapsibleTable: React.FC<InsightCardProps> = (props) => {
  const { id, title, titleWidth = 3, top, showTopOnClose, children, open, onToggle } = props

  return (
    <div id={id} className={INSIGHT_WIDGET_PRINTABLE_CLASS}>
      <InsightCardCollapsibleTableWrapper>
        <InsightCardCollapsibleTableHeader open={open} onClick={() => onToggle(!open)}>
          <InsightCardGrid container spacing={3}>
            <InsightCardGrid item xs={titleWidth}>
              <Typography variant="title2" color={Colors.textBlack}>
                {title}
              </Typography>
            </InsightCardGrid>
            {open || showTopOnClose ? top : null}
          </InsightCardGrid>
        </InsightCardCollapsibleTableHeader>
        <InsightCardCollapsibleTableContent open={open}>{children}</InsightCardCollapsibleTableContent>
        <InsightCardCollapsibleTableToggleWrapper onClick={() => onToggle(!open)} className="noprint">
          {open ? <ExpandLess size={15} /> : <ExpandMore size={15} />}
        </InsightCardCollapsibleTableToggleWrapper>
      </InsightCardCollapsibleTableWrapper>
    </div>
  )
}
